import { randomUUID } from "@frontend/utils";
import {
  EppsCustomFieldDecimalTypes,
  EppsCustomFieldTypes
} from "../models/epps-models";
import { licensedStates } from "../constants/licensedStates";
const returnCustomFieldsFromSchema = (screens) => {
  const flattenedFields = [];
  screens.filter((i) => i.type === "screen").forEach((screen) => {
    screen.fields.forEach((fieldGroup) => {
      if (fieldGroup.fields && Array.isArray(fieldGroup.fields)) {
        fieldGroup.fields.forEach((field) => {
          flattenedFields.push(field);
        });
      }
    });
  });
  const flattenedCustomFields = flattenedFields.filter(
    (field) => field.component_id.startsWith("CUSTOM")
  );
  return flattenedCustomFields;
};
const mapFieldType = (field) => {
  if (!field?.type) {
    return {};
  }
  switch (field.type) {
    case EppsCustomFieldTypes.DATE:
    case EppsCustomFieldTypes.MONTHDAY:
      return {
        type: "string",
        ui: {
          widget: "datepicker",
          col_size: 4
        }
      };
    case EppsCustomFieldTypes.DROPDOWN:
    case EppsCustomFieldTypes.DROPDOWNLIST:
      return {
        type: "enum",
        options: field.masterList.map((i) => ({
          id: i,
          text: i,
          value: i,
          visible: true
        })),
        ui: { widget: "dropdown", col_size: 4 },
        selectMultiple: false
      };
    case EppsCustomFieldTypes.YN:
      return {
        type: "enum",
        options: [
          { id: "YES", text: "Yes", value: "Y", visible: true },
          { id: "YES", text: "No", value: "N", visible: true }
        ],
        selectMultiple: false,
        ui: { widget: "dropdown", col_size: 4 }
      };
    case EppsCustomFieldTypes.X:
      return {
        type: "boolean",
        ui: { col_size: 4, widget: "checkbox" }
        // needed because boolean doesn not have col_size,
      };
    case EppsCustomFieldTypes.STRING:
    case EppsCustomFieldTypes.SSN:
    case EppsCustomFieldTypes.PHONE:
      return {
        type: "string",
        ui: { col_size: 4 }
      };
    case EppsCustomFieldTypes.INTEGER:
    case EppsCustomFieldTypes.ZIPCODE:
    case EppsCustomFieldDecimalTypes.DECIMAL:
    case EppsCustomFieldDecimalTypes.DECIMAL_1:
    case EppsCustomFieldDecimalTypes.DECIMAL_2:
    case EppsCustomFieldDecimalTypes.DECIMAL_3:
    case EppsCustomFieldDecimalTypes.DECIMAL_4:
    case EppsCustomFieldDecimalTypes.DECIMAL_5:
    case EppsCustomFieldDecimalTypes.DECIMAL_6:
    case EppsCustomFieldDecimalTypes.DECIMAL_7:
    case EppsCustomFieldDecimalTypes.DECIMAL_8:
    case EppsCustomFieldDecimalTypes.DECIMAL_9:
    case EppsCustomFieldDecimalTypes.DECIMAL_10:
      return {
        type: "number",
        ui: { col_size: 4 }
      };
    case EppsCustomFieldTypes.STATE:
      return {
        type: "enum",
        options: licensedStates.map((i) => ({
          id: i.state,
          text: i.state,
          value: i.stateAbbr,
          visible: true
        })),
        ui: { col_size: 4 },
        selectMultiple: false
      };
    default:
      return { type: "string", ui: { col_size: 4 } };
  }
};
const mapEppsCustomFields = (fields) => {
  return fields.filter((field) => !field.hidden).map((field) => ({
    ...mapFieldType(field),
    label: field.description,
    visible: !field.hidden,
    encompass_ids: [
      {
        id: `${field.newFieldId}`,
        name: field.type,
        description: `CUSTOM ${field.type}: ${field.originalFieldId}`,
        // Avoid dot notation so values don't become nested in multiple arrays
        modelPath: `unmappedLockRequestAdditionalFields.${field.newFieldId.replaceAll(
          ".",
          "*"
        )}`
      }
    ],
    component_id: `CUSTOM ${field.type}: ${field.originalFieldId}`,
    id: randomUUID(),
    disabled: !field.editable
  }));
};
export {
  mapEppsCustomFields,
  mapFieldType,
  returnCustomFieldsFromSchema
};
